/**
 *   This is a service for a specific store module.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AuthService from '@/services/auth';
import Store from '@/store/index';

export default {

  async logSupportDebug(message: string) {
    if ('NO' === process.env.VUE_APP_ISLIVE) {
      // tslint:disable-next-line:no-console
      console.log(`${new Date().toISOString().split('.')[0].replace('T', ' ')} - ` + message);
    }
  },

  async errorHandler(message: string) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'error',
      icon: Store.getters['app/icons'].error,
    });
  },

  async successHandler(message: string) {
    Store.dispatch('app/snackbar', {
      show: true,
      text: message,
      color: 'success',
      icon: Store.getters['app/icons'].success,
    });
  },

  async successHandlerWithCustomTimeout(message: string, timeout: number) {
    Store.dispatch('app/snackbarWithCustomTimeout', {
      show: true,
      text: message,
      color: 'success',
      icon: Store.getters['app/icons'].success,
      timeout: timeout,
    });
  },

  async listStatuses(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['app/statuses'].length < 1) {
      try {
        const response = await Api().get('/app/list_statuses');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            Store.dispatch('app/setStatuses', {
              statuses: [],
            });
            return response.data.message;
          } else {
            Store.dispatch('app/setStatuses', {
              statuses: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        Store.dispatch('app/setStatuses', {
          statuses: [],
        });
        if (error.response) {
          return error.response.statusText;
        } else {
          await AuthService.logSupportDebug('app.ts - listStatuses - 71 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

};
